import axios from '../../axios'

export default {
  getComplexes: function () {
    return axios.get('complexes?all=false')
  }
}



// WEBPACK FOOTER //
// ./src/services/api/ComplexesApi.js